import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import AddButton from './AddButton';
import EditButton from './EditButton';
import './GroupList.scss';

function GroupList({ list, history, deleteGroupRequest }) {
  const options = useMemo(
    () => ({
      insertBtn: AddButton,
      defaultSortName: 'name',
      defaultSortOrder: 'asc',
    }),
    [],
  );

  const getDealerCount = useCallback(x => x.length, []);

  const onEdit = useCallback(
    id => {
      history.push(`/group/${id}`);
    },
    [history],
  );

  const onDelete = useCallback(
    id => {
      deleteGroupRequest(id);
    },
    [deleteGroupRequest],
  );

  const actionFormatter = useCallback(
    (_, group) => (
      <EditButton
        onEdit={onEdit}
        onDelete={onDelete}
        onCancel={() => {}}
        group={group}
      />
    ),
    [onEdit, onDelete],
  );

  return (
    <div className="group-list-container">
      <BootstrapTable
        data={list}
        options={options}
        insertRow
        striped
        hover
        pagination
        bodyContainerClass="list-body-container"
        tableStyle={{ border: 'none' }}
      >
        <TableHeaderColumn dataField="id">ID</TableHeaderColumn>
        <TableHeaderColumn
          isKey
          dataField="name"
          dataSort
          filter={{ type: 'TextFilter', defaultValue: '' }}
        >
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataField="Dealers" dataFormat={getDealerCount}>
          Dealer Count
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="button"
          columnClassName="list-action-column"
          dataFormat={actionFormatter}
        />
      </BootstrapTable>
    </div>
  );
}

GroupList.propTypes = {
  list: PropTypes.array,
  history: PropTypes.object,
  deleteGroupRequest: PropTypes.func,
};

export default withRouter(GroupList);
